import * as api from '@/api/dashboard'
import moment from 'moment'

const state = {
  data_inicial: moment().startOf('month').format('YYYY-MM-DD'),
  data_final: moment().endOf('month').format('YYYY-MM-DD'),
  dashboard: {
    totalizadores: {
      carrinhos: 0,
      pedidos: 0,
      finalizados: 0,
      totalfinalizados: 0,
      alertaspendentes: 0,
      alertasresolvidos: 0,
      interacoes: 0,
      solicitcontato: 0,
      vendedores: []
    }
  },
  error: null,
  loading: false
}

const getters = {
  getDashboard: state => state.dashboard,
  getDataInicial: state => state.data_inicial,
  getDataFinal: state => state.data_final
}

const mutations = {
  SET_DASHBOARD (state, data) {
    state.dashboard = data
  },
  SET_ERROR (state, data) {
    state.error = data
    state.loading = false
  },
  CLEAR_ERROR (state) {
    state.error = null
  },
  SET_LOADING (state, data) {
    state.loading = data
    state.error = null
  },
  SET_DATA_INICIAL (state, data) {
    state.data_inicial = data
  },
  SET_DATA_FINAL (state, data) {
    state.data_final = data
  }
}

const actions = {
  async carregarDashboard ({ commit }, data) {
    // console.log('data-params', data)
    commit('CLEAR_ERROR')
    commit('SET_LOADING', true)
    try {
      const retorno = await api.loadDashboard(data)
      // console.log('retorno', retorno)
      commit('SET_DASHBOARD', retorno)
      return retorno
    } catch (e) {
      await commit('SET_ERROR', e)
    }
  }
}

export default { namespaced: true, state, mutations, actions, getters }
